(function($){
  $(document).ready(function(){

    $('.product__images').once('sw-product-images-slider').each(function() {
      const m = new ProductImagesSlider($(this));
    });

  });
})(jQuery);

class ProductImagesSlider {

  constructor($w){
    const _this = this;

    this.$w = $w;

    if ( this.$w.find('.product__image').length <= 1 ) {
      this.$w.find('.product__images__thumbs').hide();
      this.$w.find('.product__images__next').hide();
      return;
    }

    // Main slider
    this.$swiper = this.$w.find('.swiper');
    this.swiper = new Swiper(this.$swiper.get(0), {
      loop: true,
      slidesPerView: 1,
      speed: 300,
      followFinger: false,
      effect: 'fade',
    });
    requestAnimationFrame(function() {
      _this.updateThumbs();
    })
    this.swiper.on('slideChange', function (s) {
      _this.updateThumbs();
    });

    this.$thumbs = this.$w.find('.product__images__thumb');
    this.$thumbs.on('click', function(e) {
      const i = _this.$thumbs.index(this);
      _this.swiper.slideToLoop(i);
    });

    this.$next = this.$w.find('.product__images__next');
    this.$next.on('click', function(e) {
      _this.swiper.slideNext();
    })

    this.$w.data('sw-product-images-slider', this);
  }

  updateThumbs() {
    const i = this.swiper.realIndex;
    this.$thumbs.removeClass('product__images__thumb--active');
    this.$thumbs.eq(i).addClass('product__images__thumb--active');
  }

}
